import {browserHistory} from 'react-router';
import {takeLatest, call, select} from 'redux-saga/effects';
import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';

import {id_from_self} from 'utils/self';
import {selectEnv} from 'reducers/env';

const namespace = 'flows/routing';

// Actions
const ROUTE_DEAL_MANAGE = defineAction('ROUTE_DEAL_MANAGE', namespace);
export const routeToDealManage = createAction(ROUTE_DEAL_MANAGE.ACTION);

const ROUTE_DEAL_INTEREST = defineAction('ROUTE_DEAL_INTEREST', ['HOME', 'DEAL'], namespace);
export const routeToDealInterestFromHome = createAction(ROUTE_DEAL_INTEREST.HOME);
export const routeToDealInterestFromDeal = createAction(ROUTE_DEAL_INTEREST.DEAL);

const ROUTE_DEAL_INVEST = defineAction('ROUTE_DEAL_INVEST', ['HOME', 'DEAL'], namespace);
export const routeToDealInvestFromHome = createAction(ROUTE_DEAL_INVEST.HOME);
export const routeToDealInvestFromDeal = createAction(ROUTE_DEAL_INVEST.DEAL);

// Sagas
export function* routeDealManageSaga({payload}) {
  const {self} = payload.deal;
  yield call(browserHistory.push, self);
}

export function* routeDealInterestFromHomeSaga({payload}) {
  const {deal, invite} = payload;
  const after = btoa('/');
  const url = `/interest${deal.self}${invite.self}/after/${after}/confirm/yes`;
  yield call(browserHistory.push, url);
}

export function* routeDealInterestFromDealSaga({payload}) {
  const {deal, invite} = payload;
  const env = yield select(selectEnv);
  if (env.web) {
    const after = btoa(deal.self);
    const url = `/interest${deal.self}${invite.self}/after/${after}/confirm/yes`;
    yield call(browserHistory.push, url);
  }
}

export function* routeDealInvestFromHomeSaga({payload}) {
  const {allocation} = payload;
  const after = btoa('/');
  yield call(browserHistory.push, `/invest${allocation.self}/agreement/after/${after}/confirm/yes`);
}

export function* routeDealInvestFromDealSaga({payload}) {
  const {deal, allocation} = payload;
  const after = btoa(deal.self);
  yield call(browserHistory.push, `/invest${allocation.self}/agreement/after/${after}/confirm/yes`);
}

export function* sagas() {
  yield takeLatest(ROUTE_DEAL_MANAGE.ACTION, routeDealManageSaga);
  yield takeLatest(ROUTE_DEAL_INTEREST.HOME, routeDealInterestFromHomeSaga);
  yield takeLatest(ROUTE_DEAL_INTEREST.DEAL, routeDealInterestFromDealSaga);
  yield takeLatest(ROUTE_DEAL_INVEST.HOME, routeDealInvestFromHomeSaga);
  yield takeLatest(ROUTE_DEAL_INVEST.DEAL, routeDealInvestFromDealSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/routing/index.js